export default __webpack_public_path__ + "static/media/user.ca6677a0.svg";